module.exports = __webpack_public_path__ + "static/media/icon_61.a4e972b0.svg";